<template>
  <div class="result__nav">
    <div class="result__nav-head">
      <div class="result__nav-head-sort">
        <div class="result__nav-head-sort-fixed  hide-in-desktop">
          <button
            class="result__nav-head-sort-fixed-btn btn"
            @click="toggleFilterBoxMobile"
          >
            <i class="icon-filter" />
            <span>فیلتر</span>
          </button>

          <button
            @click="toggleSort"
            class="result__nav-head-sort-fixed-btn btn"
          >
            <i class="icon-sort" />
            <span>مرتب‌سازی</span>
          </button>
        </div>

        <div
          @click="outSideSortClick"
          v-show="isOpen"
          class="result__nav-head-sort-content"
        >
          <div ref="sortContent" class="result__nav-tour-items">
            <div class="result__nav-head-sort-items hide-in-desktop">
              <span>مرتب‌سازی</span>

              <i @click="toggleSort" class="icon-close" />
            </div>

            <label
              class="result__nav-tour-items-sort-title hide-in-not-desktop"
            >
              <i class="icon-sort" />
              <span>مرتب‌سازی: </span>
            </label>

            <ul>
              <li v-for="(sortItem, i) in sortItems" :key="i">
                <input
                  type="radio"
                  class="radio-button"
                  name="sort"
                  :id="'sort' + sortItem.id"
                  :checked="getSortType === Number(sortItem.id)"
                  @change="sortItemChange(sortItem.id)"
                />

                <label
                  :for="'sort' + sortItem.id"
                  :class="sortItem.selected ? 'radio-button-active' : ''"
                  >{{ sortItem.title }}</label
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
const root = document.getElementsByTagName("html")[0];

export default {
  name: "ResultNav",

  data() {
    return {
      sortItems: [
        { title: "ارزان ترین", id: "2", selected: true },
        { title: "گران ترین", id: "1", selected: false },
        { title: "طولانی ترین", id: "16", selected: false },
        { title: "کوتاه ترین", id: "32", selected: false },
        { title: "نزدیک ترین", id: "64", selected: false },
      ],
      sortItemActive: "2",
      showSort: false,
      isOpen: window.screen.width > 992 ?  true : false,
    };
  },
  computed: {
    ...mapGetters(["getSortType", "getTourCategoryTitle"]),
  },
  methods: {
    ...mapActions(["toggleFilterBoxMobile", "updateSort"]),

    toggleFilterMobile() {
      this.toggleFilterBoxMobile();
    },

    sortItemChange(sortId) {
      this.sortItemActive = sortId;
      this.sortSelectedItemCheck(sortId)
      this.doSort();
    },

    sortSelectedItemCheck(sortId){
      this.sortItems.map((item) => {
        if (item.id === sortId) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
    },

    doSort() {
      this.updateSort(this.sortItemActive);
      this.toggleSortBox();
      this.toggleSort();
    },

    toggleSortBox() {
      this.showSort = !this.showSort;
    },

    toggleSort() {
      if (screen.width < 992) {
        this.isOpen = !this.isOpen;
        this.toggleNoScroll();
      }
    },

    toggleNoScroll() {
      root.classList.toggle("no-scroll");
    },

    closeSort() {
      this.isOpen = false;
    },

    outSideSortClick(e) {
      if (!this.$refs.sortContent.contains(e.target) && screen.width < 992) {
        this.closeSort();
        this.toggleNoScroll();
      }
    },
  },
};
</script>

<style lang="scss">
@import "../style/modules/_resultNav.scss";
</style>
